import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Component_TagGroup } from './Component_TagGroup.js';
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import React from 'react';
export class Component_TagGroups extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.tagGroups = nextProps.tagGroups ?? [];
        return state;
    }
    //######################### Render #########################
    render() {
        const { tagGroups } = this.state;
        if (!tagGroups || !tagGroups.length)
            return _jsx("div", { style: { fontSize: '14px' }, children: "No Tags..." });
        return _jsx(_Fragment, { children: tagGroups.map(group => _jsx(React.Fragment, { children: _jsx(Component_TagGroup, { tagGroup: group }) }, group.key)) });
    }
}
;
//# sourceMappingURL=Component_TagGroups.js.map